import { IMockHandler } from '@/mock/mock.handler.interface';
import { okList, okSingle } from '@/mock/mock.response.util';
import { ALL_ACTIVITY_FIXTURES, FILE_FIXTURES, TXN_SCREENING_FIXTURES } from '@/mock/txn-screening/txn-screening.fixtures';

const ID_ROUTE = /\/txn-screening\/([^/?]+)$/;

export const txnScreeningHandler: IMockHandler = {
    matches(req: any) {
        if (req.url.includes('/assets/i18n/') || req.url.includes('assets/i18n/')) {
            return false;
        }

        return req.url.includes('/txn-screening');
    },

    handle(req: any) {
        const { method, url } = req;
        const idMatch = url.match(ID_ROUTE);

        // ── GET /txn-screening/activity/all ──────────────────────────────────
        if (method === 'GET' && url.includes('/txn-screening/activity/all')) {
            return okList(ALL_ACTIVITY_FIXTURES);
        }

        // ── GET /txn-screening/files ──────────────────────────────────────────
        if (method === 'GET' && url.includes('/txn-screening/files')) {
            return okList(FILE_FIXTURES);
        }

        // ── GET /txn-screening/:id ────────────────────────────────────────────
        if (method === 'GET' && idMatch) {
            const found = TXN_SCREENING_FIXTURES.find((u) => String(u.id) === idMatch[1]);
            return found ? okSingle(found) : okSingle(null);
        }

        // ── GET | POST /txn-screening  (list / search) ───────────────────────
        if (method === 'GET' && url.endsWith('/txn-screening')) {
            const page = Number(req.params.get('page') ?? 0);
            const size = Number(req.params.get('size') ?? 10);
            return okList(TXN_SCREENING_FIXTURES, page, size);
        }
        throw new Error(`[TxnScreeningHandler] unhandled: ${method} ${url}`);
    }
};
